import { defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import EditableHeading from '@smartfire/components/editable-heading';
import EditableText from '@smartfire/components/editable-text';
import Button from '../../button/block';
import React from 'react';
import clsx from 'clsx';
import { useIntersection } from '../../hook/useIntersection';
import { useRef } from 'react';

const Inspector = React.lazy(() => import('./Inspector'));

function Mission({ textButton, blank, link, color, colorHover, image }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    const ref = useRef();
    const inViewport = useIntersection(ref, '0px', 0.8);

    return (
        <div ref={ref} className={clsx(style.blockMission, !image && style.oneColumn)}>
            {image && (
                <img
                    src={image.url}
                    alt={image.compat.meta ? image.compat.meta : image.title ? image.title : 'Icon Mission'}
                    className={clsx(style.imageMission, (inViewport || isEditing) && style.reveal)}
                />
            )}
            <div className={style.contentMission}>
                <div
                    className={clsx(style.title, (inViewport || isEditing) && style.reveal)}
                    style={{ background: color }}
                >
                    <EditableHeading
                        smartProp={'title'}
                        placeholder={'Insérez le titre'}
                        className={style.titleMission}
                    />
                </div>
                <EditableText
                    tagName={'p'}
                    smartProp={'text'}
                    placeholder={'Insérez le texte'}
                    allowedFormats={['core/bold', 'core/italic', 'core/link', 'core/text-color']}
                    className={clsx(style.text, (inViewport || isEditing) && style.reveal)}
                />
                <Button
                    text={textButton}
                    blank={blank}
                    link={isEditing ? undefined : link}
                    color={color}
                    colorHover={colorHover}
                    inspector={false}
                    aspect={'arrow'}
                    classNames={clsx(style.button, (inViewport || isEditing) && style.reveal)}
                />
            </div>
        </div>
    );
}

export default defineBlock({
    Block: Mission,
    smartProps: {
        image: smartProps.image,
        title: smartProps.object.withDefault({
            headingLevel: 3,
            content: '',
        }),
        text: smartProps.string.withDefault(''),
        textButton: smartProps.string.withDefault('En savoir plus'),
        link: smartProps.string.withDefault('/'),
        blank: smartProps.bool.withDefault(false),
        color: smartProps.string.withDefault('#044251'),
        colorHover: smartProps.string.withDefault('#086d84'),
    },
    setup: {
        title: 'Mission',
        parent: ['smartfire/missions'],
    },
});
